<div class="min-h-screen flex flex-col">
  <app-header></app-header>
  <main class="flex-1 py-8">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
